import { Link } from 'react-router-dom';
import { products, featuredProductIds } from '@/mocks/products';

export default function FeaturedProducts() {
  const featured = products.filter((p) => featuredProductIds.includes(p.id));

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-primary-500 tracking-widest mb-2">
            ✦ FEATURED ✦
          </p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            精选好物
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            为你挑选最受欢迎的嫩小兔产品，每一款都值得拥有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {featured.map((product) => (
            <Link
              key={product.id}
              to="/category"
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-square overflow-hidden bg-background-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  {product.isNew && (
                    <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                      新品
                    </span>
                  )}
                  {product.isHot && (
                    <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      热卖
                    </span>
                  )}
                  {product.isLimited && (
                    <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-200 text-secondary-800 whitespace-nowrap">
                      限定
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {product.name}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {product.description}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-label text-base md:text-lg font-bold text-primary-500">
                    {product.price}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                    查看详情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-100 text-foreground-800 font-medium text-sm hover:bg-primary-50 hover:text-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看全部产品
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}